import { Injectable } from '@angular/core';
import type { DcrDialogCloser } from './dcr-dialog.service';

/**
 * Reference to an open dialog instance, injected into dynamically created dialog content components.
 *
 * @typeParam D - Type of data shared between opener and dialog component
 *
 * @example
 * ```typescript
 * export class NameFormDialogComponent {
 *   dialogRef = inject<DcrDialogRef<{ prefill?: string; name?: string }>>(DcrDialogRef);
 *
 *   onInput(e: Event) {
 *     this.dialogRef.data = { ...this.dialogRef.data, name: (e.target as HTMLInputElement).value };
 *   }
 * }
 * ```
 */
@Injectable()
export class DcrDialogRef<D = unknown> {
  /** Data shared between the opener and the dialog component. */
  data?: D;

  /** @internal Set by the service. */
  _service!: DcrDialogCloser;

  close(action: 'confirm' | 'close' | 'cancel' = 'close', data?: D): void {
    if (data !== undefined) {
      this.data = data;
    }
    this._service._closeActive(action);
  }

  confirm(data?: D): void {
    this.close('confirm', data);
  }

  cancel(data?: D): void {
    this.close('cancel', data);
  }
}
